module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO VERTICAL X-fb6fa7906c87567d5a0b04491a41fbaa.png";